import Authform from "../components/Authform/Authform";
import Footer from "../components/Footer/Footer";



export default function Authentication () {

  return (
    <div>
      <Authform />
      <Footer />
    </div>
  )
}

